// extracted by mini-css-extract-plugin
module.exports = {"hero-container":"NoImageHero_hero-container__KOdTw","headline":"NoImageHero_headline__y8eDj","body":"NoImageHero_body__p3vCl","search-fade-in":"NoImageHero_search-fade-in__ZDr_b"};